/* eslint-disable */

export default function slideDoor(node) {
  //容器对象
  var box = document.querySelector('#sliding-door');

  // //获得图片NodeList对象集合
  var imgs = box.children;

  // //设置掩藏门体露出的宽度
  var exposeWidth = 165;
  // //计算每道门打开时应移动的距离
  var openWidth = 540;
  //为每道门绑定事件

  for (let i = 0; i < imgs.length; i++) {
    if (i === 0) {
      imgs[i].classList.add('hover');
      imgs[i].style.width = openWidth + 'px';
    } else {
      imgs[i].classList.remove('hover');
      imgs[i].style.width = exposeWidth + 'px';
    }
  }

let timer =null;

  for (let i = 0; i < imgs.length; i++) {
    //为了获得不同的i值，使用立即调用的函数表达式
    (function(i) {
      imgs[i].onmouseover = function() {
        //先将每道门复位
        // setImgsPos();
        //打开门
        clearTimeout(timer);
        timer = setTimeout(()=>{
          for (let j = 0; j < imgs.length; j++) {
            if (j === i) {
              imgs[i].classList.add('hover');
              imgs[i].style.width = openWidth + 'px';
            } else {
              imgs[j].classList.remove('hover');
              if (j !== imgs.length) imgs[j].style.width = exposeWidth + 'px';
            }
          }
        },120);
      }
    })(i);
  };
}